import { CustomersCanvasService } from './../../../../services/inventory/customerscanvas.service';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from '@angular/core';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { HelperService } from "./../../../../services/core/helper.service";

//Models
import { SeoViewModel } from "./../../../../models/core/seo";

//Services
import { NewsletterService } from '../../../../services/cms/newsletter.service';

import { Subscription } from 'rxjs/Subscription';
import { CacheService } from '../../../../services/core/cache.service';
import { DOCUMENT } from '@angular/platform-browser';
import { Meta } from '../../../../services/core/angular2-meta';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ''
})

export class HomeComponent implements OnInit {
    data: any = {};

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            private scriptService: ScriptService,
            @Inject(DOCUMENT) private document: any
        ) {
        this._compiler.clearCache();
    }

    subManager = new Subscription();

    ngOnInit() {
        let homePageInfo: any;

        let homeSub = this.cmsComponentService.getHomePageDataOptimized().subscribe(result => {
             if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }

            if (this.isBrowser) {
                homePageInfo = result;
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(homePageInfo);

                this._elementRef.clear();
                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                 //-- Get head and body scripts
                 this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage ,this.scriptService.homeId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(homeSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
        // this.cache.clearAll();
    }

    //Creates component to inject
    private createSubComponent(homePageInfo: any) {
        @Component({
            template: homePageInfo.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private routeService: RoutesService,
                    private seoService: SeoService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private helperService: HelperService,
                    private newsletterService: NewsletterService,
                    private componentHelper: ComponentHelperService,
                    private cache: CacheService,
                    public canvasService: CustomersCanvasService,
                    private metaService: Meta,
            ) { }

            private homeIsInit: boolean = false;

            private productsPageName: string[] = [];
            private promotionsPageName: string[] = [];

            private categories: any = homePageInfo.Categories;
            private highlights: any = homePageInfo.Highlights;
            private promotions: any = homePageInfo.Promotions;
            private seoInfo: SeoViewModel = homePageInfo.SeoInformation;
            private articles: any = homePageInfo.ArticleCategoryList;

            private headerData: any = homePageInfo.HeaderData;
            private footerData: any = homePageInfo.FooterData;
            private sideMenuData: any = homePageInfo.SideMenuData;
            private sliderData: any = homePageInfo.SliderData;

            //newsletter subsciption
            private newsletterSubmitted: boolean = false;
            private privacySubmitted: boolean = false;
            private alreadySubscribed: boolean = false;
            private successfullySubscribed: boolean = false;
            private spinnerNewslatter: boolean = false;

            private model = {
                Email: "",
                CheckboxSubscribe: false
            };

            subManager = new Subscription();

            // private breadcrumbs : Breadcrumbs[] = homePageInfo.BreadcrumbsInfo;

            ngOnInit() {

                // setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.sideMenuData.Categories = this.headerData.Categories;
                this.productsPageName = this.routeService.getRoutePath('CATALOGO PRODOTTI (HOME)');
                this.promotionsPageName = this.routeService.getRoutePath('CATALOGO - PRODOTTI IN OFFERTA');
            }


            filteraArticleOfType(type, numReturn) {
                let count = 1;
                let result = new Array<any>();
                let res = this.articles.filter(x => x.Code_Category == type);
                for (let item of res) {
                    if (count > numReturn) {
                        return result;
                    }
                    result.push(item);
                    count++;
                }
                return result;
            }

            onSubmit(form) {
                this.spinnerNewslatter = true;
                if (form) {
                    let newsSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(result => {
                        if (result == "-1") {
                            this.alreadySubscribed = true;
                            this.successfullySubscribed = false;
                            this.spinnerNewslatter = false;
                        }

                        else {
                            this.alreadySubscribed = false;
                            this.successfullySubscribed = true;
                            this.spinnerNewslatter = false;
                        }
                    });

                    this.subManager.add(newsSub);
                }

                else {
                    this.spinnerNewslatter = false;
                }
            }

            imageTitle(imgPath) {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.homeIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                layoutTheme.initCarousel();
                layoutTheme.initAnimate();
                layoutTheme.initVideo();

                //Eventually retrieving the script to append
                // if (this.seoInfo.HasScripts == true) {
                //     this.scriptService.appendHomeScript(this._elementRef.element.nativeElement);
                // }

                this.homeIsInit = true;
            }

            nullifyAllReferences() {
                homePageInfo = null;
                this.productsPageName = null;
                this.promotionsPageName = null;

                this.categories = null;
                this.articles = null;
                this.highlights = null;
                this.promotions = null;
                this.seoInfo = null;

                this.headerData = null;
                this.footerData = null;
                this.sideMenuData = null;
                this.sliderData = null;
                this.model.CheckboxSubscribe = null;
                this.model.Email = null;
            }

            doSomething() {
                this.nullifyAllReferences();
                this.subManager.unsubscribe();
                this.componentHelper.clearMemory();
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.nullifyAllReferences();
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/homepage/sys/home.component.ts